import { IoMdMore } from "react-icons/io";
import { LuUser, LuUsers2 } from "react-icons/lu";
import { GoDotFill } from "react-icons/go";
import { useNavigate } from "react-router-dom";
 
import { isButtonElement } from "react-router-dom/dist/dom";
import { useStateSetter } from "../../../../hooks/statehooks/UseStateSettersHook";
import { Menu, Transition } from "@headlessui/react";
import { CiEdit } from "react-icons/ci";
import { FiFileMinus } from "react-icons/fi";
import { MdDelete } from "react-icons/md";
import { Fragment } from "react/jsx-runtime";
import ContracctDetails from "../ContracctDetails";
import EditLeavePolicy from "../../../../components/Modules/Employees/EditLeavePolicy";
import { useState } from "react";
import useLeaveHook from "../../../../hooks/useLeaveHook";

export default ({ item }: any) => {
  const navigate = useNavigate();
  const { setSelecteduser } = useStateSetter();
  const {getOrgLeavePolicies} =useLeaveHook()
const [showeditpolicy, setshoweditpolicy] =useState(false)
const styleite="px-2 py-1 bg-faintBlue mx-[2px] rounded"
  const {setSidebarRenderView}=useStateSetter()

  return (
    <div

      onClick={() => {
       // setSidebarRenderView(<EmployeeDetailed  id={item.id} />)
      }}
      className="bg-whit  shadow-sm border border-gray-200 rounded-[10px] my-2 flex  py-6  px-1 justify-between items-center"
    >

      
    {showeditpolicy &&  <EditLeavePolicy
         item={item}
         refresh={getOrgLeavePolicies}
         show={setshoweditpolicy}
       />
     }
      <div className="flex">
        
        <div className=" px-2">
          <p className="font-semibold text-md cursor-pointer mb-2">
            {item.leaveType.leaveName} <LuUsers2 className="inline" /> {item.employeeGroup}
          </p>
          <p className="font-light text-[10px] cursor-pointer">
           <span className={styleite}>
           Accrual rate: {item.accuralRate}
           </span>
           <span className={styleite}>
           Accrual limit: {item.accuralLimit}
           </span>
           <span className={styleite}>
         Carryover:   {item.carryOverLimit}
           </span>
           <span className={styleite}>
          Expiry date:  {item.carryOverExpiryDate}
           </span>
           <span className={styleite}>
           Probation: {item.probationPeriod}
           </span>
           
          </p>
         
          <div>
           
           
           
          </div>
        </div>
      </div>

      <Menu as="div" className={`relative my-2 `}>
        <Menu.Button className="   w-full       ">
          <div className="flex flex-items items-center  w-full gap-4">
            <div className=" flex justify-between w-full  items-center p-1">
              <IoMdMore size={20} className="text-textbg " />
            </div>

            <div className="flex items-center"></div>
          </div>
        </Menu.Button>

        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items
             className="origin-top-left z-10 absolute   mt-2 rounded-sm shadow-md p-1 bg-white w-full  max-h-[200px] min-w-[150px]   overflow-x-hidden overflow-y-scroll ring-1 ring-black ring-opacity-5 focus:outline-none"
          >
            <Menu.Item>
              <p
                onClick={() => {
                  setshoweditpolicy(true)
                }}
                className=" text-xs font-light w-full text-black p-3 m-2 cursor-pointer truncate hover:bg-customGray "
              >
                <CiEdit className="inline" /> Edit
              </p>
            </Menu.Item>
         
            <Menu.Item>
              <p
                onClick={() => {}}
                className=" text-xs font-light w-full text-black p-3 m-2 cursor-pointer truncate hover:bg-customGray "
              >
                <MdDelete className="inline" /> Delete
              </p>
            </Menu.Item>
          </Menu.Items>
        </Transition>
      </Menu>   
       </div>
  );
};
